import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import "./OutOfStock.css";
import MobileTopBar from "../../components/mobile/MobileTopBar";
import Footer from "../../components/shared/Footer";
import useResponsive from "../../hooks/useResponsive";
import { unsubscribe as content, EMAIL_ADDRESS } from "../../Data/siteContent";
import { UNSUBSCRIBE_NEWSLETTER_API_URL, UNSUBSCRIBE_WAITINGLIST_API_URL } from "../../Data/apiEndpoints";

const Unsubscribe = () => {
  const isMobile = useResponsive();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("confirm");

  const type = searchParams.get("type") || "newsletter";
  const email = searchParams.get("email");
  const product = searchParams.get("product");

  const invalidParams = !email || (type === "waitinglist" && !product);

  const handleConfirm = async () => {
    setStatus("loading");
    try {
      const apiUrl = type === "waitinglist" ? UNSUBSCRIBE_WAITINGLIST_API_URL : UNSUBSCRIBE_NEWSLETTER_API_URL;
      const body = type === "waitinglist" ? { email, product } : { email };

      const res = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      if (res.ok) setStatus("success");
      else if (res.status === 404) setStatus("not-found");
      else setStatus("error");
    } catch {
      setStatus("error");
    }
  };

  const typeContent = content[type] || content.newsletter;
  const effectiveStatus = invalidParams ? "invalid" : status;

  const productLabel = product ? product.toUpperCase() : "";
  const resolve = field => (typeof field === "function" ? field(productLabel) : field);

  const titleMap = {
    confirm: resolve(typeContent.confirmTitle),
    loading: content.loadingTitle,
    success: resolve(typeContent.successTitle),
    invalid: content.invalidTitle,
    "not-found": resolve(typeContent.notFoundTitle),
    error: content.errorTitle,
  };

  const messageMap = {
    confirm: resolve(typeContent.confirmMessage),
    loading: "",
    success: resolve(typeContent.successMessage),
    invalid: content.invalidMessage,
    "not-found": resolve(typeContent.notFoundMessage),
    error: (
      <>
        {content.errorMessage} <a href={`mailto:${EMAIL_ADDRESS}`}>{EMAIL_ADDRESS}</a>
      </>
    ),
  };

  return (
    <div className="outofstock-container" style={{ paddingLeft: 0, paddingRight: 0 }}>
      {isMobile && <MobileTopBar />}
      <h1 className="outofstock-title">{titleMap[effectiveStatus]}</h1>
      <section className="outofstock-info">
        <p>{messageMap[effectiveStatus]}</p>
      </section>
      {effectiveStatus === "confirm" && (
        <div style={{ display: "flex", justifyContent: "center", marginTop: "1.5rem", marginBottom: "2.5rem" }}>
          <button type="button" className="outofstock-button" onClick={handleConfirm}>
            {content.confirmButton}
          </button>
        </div>
      )}
      {isMobile && <Footer />}
    </div>
  );
};

export default Unsubscribe;
